/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '.';

export const useGetGroupSuseplob = () => useApi(`/v2/group-suseplob`, 'GET', {}, {}, true);

export const useGetGroupSuseplobById = () => useApi(`/v2/group-suseplob/id`, 'GET', {}, {}, true);
